export type Comparator<T> = (o1: T, o2: T) => number;

export function quickSort<T>(array: T[], compare: Comparator<T>): void {
	if (array.length <= 1 || array == null) {
		return;
	}
	sort(array, compare, 0, array.length - 1);
}

function sort<T>(
	array: T[],
	compare: Comparator<T>,
	low: number,
	high: number
): void {
	if (low < high) {
		const partIndex = partition(array, compare, low, high);
		sort(array, compare, low, partIndex - 1);
		sort(array, compare, partIndex + 1, high);
	}
}

function partition<T>(
	array: T[],
	compare: Comparator<T>,
	low: number,
	high: number
): number {
	const pivot: T = array[high];
	let i: number = low - 1;
	for (let j = low; j <= high - 1; j++) {
		if (compare(array[j], pivot) == -1) {
			i = i + 1;
			swap(array, i, j);
		}
	}
	if (compare(array[high], array[i + 1]) == -1) {
		swap(array, i + 1, high);
	}
	return i + 1;
}

function swap<T>(array: T[], i: number, j: number): void {
	const newJ: T = array[i];
	array[i] = array[j];
	array[j] = newJ;
}

export function QS(arr: any[]): void {
	// Quicksort será do maior para o menor
	// Caso queira inverter, apenas trocar o -1 por 1 e vice-versa

	function numberComparator(o1: any, o2: any): number {
		if (o1.cases < o2.cases) {
			return 1;
		} else if (o1.cases === o2.cases) {
			return 0;
		}
		return -1;
	}

	quickSort(arr, numberComparator);
}
